<main>
  <!-- <a id="btnCnsltNav" class="nav-link text-white d-none" routerLinkActive="active" [routerLink]="['/home/consultation']"
    (click)="changeMenu()">Doctor Consultation</a> -->
  <div id="slide-panel">
    <a id="opener"><img src="../../../assets/images/side_btn.png" /></a>
    <div>
      <nav>
        <a id="btnCnsltNav" class="nav-link text-white" routerLinkActive="active" [routerLink]="['/home/consultation/cn']"
          (click)="changeMenu()">Doctor Consultation</a>
        <a class="nav-link text-white" routerLinkActive="active" [routerLink]="['/home/appointment']"
          (click)="changeMenu()">Appointment Schedule</a>
        <a class="nav-link text-white" routerLinkActive="active" [routerLink]="['/home/payment']"
          (click)="changeMenu()"> Payment Status</a>
        <a class="nav-link text-white" routerLinkActive="active" [routerLink]="['/home/support']"
          (click)="changeMenu()">Support</a>
      </nav>
    </div>
  </div>
  <div class="container-fluid  paddingbottompoc" style="margin-top:5rem;">
    <button type="button" style="display: none;" id="pocforopen" (click)="showHideVideo2()"></button>
    <button type="button" style="display: none;" id="navigatepoc" (click)="navigatepocclick()"></button>
    <button type="button" style="display: none;" id="docDiscconectCall" (click)="docSkipCallclick()"></button>
    <button type="button" style="display: none;" id="navigatepocispocgiven" (click)="navigatepocIsPocGivenTrueclick()"></button>
    <div class="row mb-2">
      <div class="col-xl-3 h-100">
        <div class="card margingtop" style="border-radius: 1rem;" *ngIf="is_self">
          <div class="card-body pt-0 bg_color small">
            <div class=""><span class="text-center patient-info text-white pl-2 pr-2 pt-1 pb-1"
                style="display:table; margin:0 auto;">Patient Information</span></div>
            <p class="mb-2"><span><strong>Patient Name</strong></span>:<span>
                <!-- {{benData?.first_name.toUpperCase() + ' ' +  benData?.middle_name.toUpperCase() + '' + benData?.last_name.toUpperCase()}} -->
                 {{benData?.first_name  | uppercase }}  {{benData?.middle_name  | uppercase }}   {{benData?.last_name  | uppercase }}
              </span>
              
              </p>
            <p class="mb-2"><span><strong>Gender</strong></span>:<span>
                {{getGender(benData?.gender_id)}}</span><span class="ml-4"><strong>Age</strong></span>:<span>
                {{benData?.age}}</span></p>
            <p class="mb-2"><span><strong>Symptoms</strong></span>:<span> {{(symptoms||'')}}</span></p>
            <!-- <p class="mb-2" *ngIf="!is_self"><span><strong>Registered Name</strong></span>:<span> {{registered_name}}</span></p> -->
            <p class="mb-2"><span><strong>Reg Number</strong></span>:<span> {{benId}}</span></p>
            <p class="mb-2"><span><strong>ABHA Address</strong></span>:<span *ngIf="healthidaddress=='null'"> </span><span *ngIf="healthidaddress!='null'"> {{healthidaddress}}</span></p>
            <p class="mb-2"><span><strong>ABHA Number</strong></span>:<span *ngIf="healthidnumber=='null'"> </span><span *ngIf="healthidnumber!='null'"> {{healthidnumber}}</span></p>
            <p class="mb-2"><span><strong>Mobile
                  Number</strong></span>:<span>{{benData?.member_mobile==null?benData.mobile:benData.member_mobile}}</span>
            </p>
            <p class="mb-2"><span><strong>Address</strong></span>:<span> {{benData?.address}}</span></p>
            <p class="mb-2" *ngIf="isukt"><span><strong>Consultation Type</strong></span>:
              <input type="radio" name="consultationType" [(ngModel)]="consType" [ngModelOptions]="{standalone: true}" value="New"
                  >New
              <input type="radio" name="consultationType" [(ngModel)]="consType" [ngModelOptions]="{standalone: true}" value="Follow Up" data-toggle="modal" data-target="#patientModal"
                 >Follow Up
          </p>
            <div class="float-right">
              <button class="badge badge-danger mb-1" type="button" data-toggle="modal" data-target="#emergencyModal"
                (click)="emergencyComment=''">
                <i class="fa fa-eye" aria-hidden="true"></i> <strong> Emergency</strong>
              </button> &nbsp;
              <button class="badge badge-dark mb-1" type="button" (click)="openViewFileModal()">
                <i class="fa fa-eye" aria-hidden="true"></i> <strong> View Files</strong>
              </button>
              <button class="badge badge-warning mb-1" type="button" data-toggle="modal" data-target="#patientModal">
                <i class="fa fa-history" aria-hidden="true"></i><strong> Patient History </strong>
              </button>&nbsp;
              <button class="badge badge-info mb-1" type="button" (click)="openModal()">
                <i class="fa fa-align-justify" aria-hidden="true"></i><strong> Covid Form </strong>
              </button>&nbsp;
              <button class="badge badge-info mb-1" type="button" (click)="viewID()" *ngIf="isukt">
                <i class="fa fa-align-justify" aria-hidden="true"></i><strong> ID Proof </strong>
              </button>&nbsp;
              <button class="badge badge-danger mb-1" type="button" data-toggle="modal" data-target="#audioConsent"
               (click)="audioConsent()"  *ngIf="isukt && !isOffLinePOC() && ( audio_file_path|| audio_file_path2 || audio_file_path3)">
              <i class="fa fa-eye" aria-hidden="true"></i> <strong> Audio consent</strong>
            </button> &nbsp;
              <!-- <button && !isOffLinePOC() class="badge badge-info mb-1" type="button" (click)="audioConsent()" *ngIf="isukt">
                <i class="fa fa-align-justify" aria-hidden="true"></i><strong> Audio consent</strong>
              </button>&nbsp; -->
              <!-- commented below lines consult doctor 28-06-2022 -->
              <!-- <button class="badge badge-primary mb-1" type="button"
              (click)="openPatientModal()" *ngIf="isOffLinePOC() == true"
                  >Consult Doctors
              </button> -->
            <!-- <div class="badge badge-info mb-1">
              <a (click)="imagePath='';viewID()"><i class="fa fa-id-card" aria-hidden="true"></i></a>
            </div>&nbsp;ID Proof -->
            <!-- <div class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
              <a (click)="imgPath='';onViewPresOld(item)"> <i class="fa fa-eye text-white"></i></a> <!-- item -->
              <!-- openModal(item) -->
           
              <!-- <button class="badge badge-info" type="button" (click)="openModal()">
                <i class="fa fa-align-justify" aria-hidden="true"></i><strong> Covid Form </strong>
              </button> -->
              <!-- <input type="button" onclick="stopVideo()" class="btn btn-sm btn-success"  value="Close Video"> -->
            </div> <br />
            <div class="custom-control-inline custom-control custom-checkbox" *ngIf="isShowDP">
              <input class="custom-control-input" type="checkbox" id="cb1"
                (change)="onEpaperChng($event.target.checked)">
              <label class="custom-control-label" for="cb1"><strong>Digital Prescription</strong></label>
            </div>
            <div class="mt-2">
              <span class="float-left pt-4">
                <button class="badge badge-danger mb-1" type="button" 
                (click)="gotoConsultation()">
                <i class="fa fa-times" aria-hidden="true"></i> <strong> Cancel POC</strong>
              </button>&nbsp;&nbsp;
              <!-- <button class="badge badge-primary mb-1" type="button"
              (click)="openPatientModal()" *ngIf="isOffLinePOC() == true"
                  >Consult Doctors
              </button> -->
            <!-- <button type="button" class="btn btn-sm btn-danger" (click)="gotoConsultation()">Cancel POC</button> -->
          </span>
            <!-- <button type="button" class="btn btn-sm btn-danger" (click)="showHideVideo()">Show/Hide Video</button> -->
         <!-- <span class="float-right" *ngIf="!isOffLinePOC()"> -->
         <span class="float-right" *ngIf="!isOffLinePOC()">
          <label for="switch" class="font-weight-bold">Show  Video</label>
            <div class="switchToggle">
              <input type="checkbox" checked id="switch"  (click)="showHideVideo()">
              <label for="switch"></label>
            </div>
          </span>
          </div>
          </div>
        </div>
        <div class="card margingtop" style="border-radius: 1rem;" *ngIf="!is_self">
          <div class="card-body pt-0 bg_color small">
            <div class=""><span class="text-center patient-info text-white pl-2 pr-2 pt-1 pb-1"
                style="display:table; margin:0 auto;">Member Information</span></div>
            <p class="mb-2"><span><strong>Member Name</strong></span>:<span>
                {{depDtls?.first_name?.toUpperCase() + ' ' + depDtls?.last_name?.toUpperCase()}}</span></p>
            <p class="mb-2"><span><strong>Gender</strong></span>:<span>{{getGender(depDtls?.gender_id)}}</span><span
                class="ml-4"><strong>Age</strong></span>:<span> {{depDtls?.age}}</span></p>
            <p class="mb-2"><span><strong>Symptoms</strong></span>:<span> {{(symptoms||'')}}</span></p>
            <!-- <p class="mb-2" *ngIf="!is_self"><span><strong>Registered Name</strong></span>:<span> {{registered_name}}</span></p> -->
            <p class="mb-2"><span><strong>Reg Number</strong></span>:<span> {{depId}}</span></p>
            <p class="mb-2"><span><strong>Mobile Number</strong></span>:<span>{{depDtls?.member_mobile == null ?
                depDtls?.mobile : depDtls?.member_mobile}}</span></p>
            <p class="mb-2"><span><strong>Address</strong></span>:<span> {{depDtls?.address}}</span></p>
            <p class="mb-2" *ngIf="isukt"><span><strong>Consultation Type</strong></span>:
              <input type="radio" name="consultationType" [(ngModel)]="consType" [ngModelOptions]="{standalone: true}" value="New"
                  >New
              <input type="radio" name="consultationType" [(ngModel)]="consType" [ngModelOptions]="{standalone: true}" value="Follow Up" data-toggle="modal" data-target="#patientModal"
                 >Follow Up
          </p>
            <div class="float-right">
              <button class="badge badge-danger" type="button" data-toggle="modal" data-target="#emergencyModal"
                (click)="emergencyComment=''">
                <i class="fa fa-eye" aria-hidden="true"></i> <strong> Emergency</strong>
              </button>
              <button class="badge badge-dark" type="button" (click)="openViewFileModal()">
                <i class="fa fa-eye" aria-hidden="true"></i> <strong> View Files</strong>
              </button>
              <button class="badge badge-warning" type="button" data-toggle="modal" data-target="#patientModal">
                <i class="fa fa-history" aria-hidden="true"></i><strong> Patient History </strong>
              </button>
              <li class="list-inline-item"> <button type="button" class="btn btn-sm btn-primary mb-2 font-weight-bold"
                type="button" (click)="openLink()"> HIMS Files</button></li>
              <button class="badge badge-info" type="button" (click)="openModal()">
                <i class="fa fa-align-justify" aria-hidden="true"></i><strong> Covid Form </strong>
              </button>
              <button class="badge badge-info mb-1" type="button" (click)="viewID()" *ngIf="isukt">
                <i class="fa fa-align-justify" aria-hidden="true"></i><strong> ID Proof </strong>
              </button>&nbsp;
            </div> <br />
            <!-- Doctor Consult commented below -->
            <button class="badge badge-primary mb-1" type="button"
            (click)="openPatientModal()" *ngIf="isOffLinePOC() == true && !hideConsultDoctorButtonInPOC">Consult Doctors</button>
            <div class="custom-control-inline custom-control custom-checkbox" *ngIf="isShowDP">
              <input class="custom-control-input" type="checkbox" id="cb1"
                (change)="onEpaperChng($event.target.checked)">
              <label class="custom-control-label" for="cb1"><strong>Digital Prescription</strong></label>
            </div>
            <div class="mt-2">
              <span class="float-left pt-4">
                <button class="badge badge-danger mb-1" type="button" 
                (click)="gotoConsultation()">
                <i class="fa fa-times" aria-hidden="true"></i> <strong> Cancel POC</strong>
              </button>

            <!-- <button type="button" class="btn btn-sm btn-danger" (click)="gotoConsultation()">Cancel POC</button> -->
          </span>
            <!-- <button type="button" class="btn btn-sm btn-danger" (click)="showHideVideo()">Show/Hide Video</button> -->
         <!-- <span class="float-right" *ngIf="!isOffLinePOC()"> -->
         <span class="float-right" *ngIf="!isOffLinePOC()">
          <label for="switch" class="font-weight-bold">Show  Video</label>
            <div class="switchToggle">
              <input type="checkbox" checked id="switch" (click)="showHideVideo()">
              <label for="switch"></label>
            </div>
          </span>
          </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 h-100">
        <div class="">
          <div class="drag" id="drogVideo">
            <div class="card videobg shadow videoalign">
              <div class="card-header pb-1 pt-1 text-white mx-auto">Video Consultation</div>
              <div class="card-body pt-1">
                <div id="conference_div">
                  <div id="container" style="height:285px !important;">
                    <!-- <video id="localStream" autoplay controls
            class='localStream doc_video'></video>
        <video muted autoplay controls class='remoteStream pat_video'></video> -->
                    <openvidu-webcomponent style="display: none;"></openvidu-webcomponent>
                  </div>
                  <div>
                    <input id="convId" type="hidden" />
                  </div>
                  <div>
                    <ul id="log" style="display: none;"></ul>
                    <!-- <button onclick="window.app.leaveConversation()"
                          class="btn btn-sm btn-danger">Hang Up</button>&nbsp;
                      <button class="btn btn-sm btn-success">Confirm</button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="card videobg shadow videoposition videoalign">
          <div class="card-header pb-1 pt-1 text-white mx-auto">Video Consultation</div>
          <div class="card-body p-4"></div>
        </div> -->
      </div>
      <div class="col-xl-3 h-100">
        <!-- <div class="card margingtop" style="border-radius: 1rem;" *ngIf="!is_self">
          <div class="card-body pt-0 bg_color small">
            <div class=""><span class="text-center patient-info text-white pl-2 pr-2 pt-1 pb-1"
              style="display:table; margin:0 auto;">Patient Information</span></div>
            <p class="mb-2"><span><strong>Patient Name</strong></span>:<span>
                {{benData?.first_name.toUpperCase() + ' ' + benData?.last_name.toUpperCase()}}</span></p>
            <p class="mb-2"><span><strong>Gender</strong></span>:<span>
                {{getGender(benData?.gender_id)}}</span><span
                class="ml-4"><strong>Age</strong></span>:<span> {{benData?.age}}</span></p>
            <p class="mb-2"><span><strong>Symptoms</strong></span>:<span> {{(symptoms||'')}}</span></p>
            <p class="mb-2" *ngIf="!is_self"><span><strong>Registered Name</strong></span>:<span> {{registered_name}}</span></p>
            <p class="mb-2"><span><strong>Reg Number</strong></span>:<span> {{benId}}</span></p>
            <p class="mb-2"><span><strong>Mobile Number</strong></span>:<span>{{benData?.member_mobile==null?benData.member_mobile:benData.member_mobile}}</span></p>
            <p class="mb-2"><span><strong>Address</strong></span>:<span> {{benData?.address}}</span></p>
          </div>
        </div> -->
      </div>
    </div>
    <!-- Voice Recognition -->
    <div *ngIf="isQA">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <div class="form-group">
            <textarea id="taST" rows="6" class="form-control" style="resize: none;"
              placeholder="You can see voice text here" readonly disabled></textarea>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
      <div class="container">
        <button id="btnSpch" class="btn outlineColor">
          <i class="fa fa-microphone" aria-hidden="true"></i>
          <div id="ringDiv" class="pulse-ring"></div>
        </button>
      </div> <br />
      <!-- <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <input type="text" id="tbCC" class="form-control" placeholder="Chief Complaints">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input type="text" id="tbOC" class="form-control" placeholder="Other Complaints">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input type="text" id="tbHPI" class="form-control" placeholder="History of Present Illness">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input type="text" id="tbFH" class="form-control" placeholder="Family History">
          </div>
        </div>
      </div>
      <label id="activity"></label> -->
    </div>
    <!-- <button data-toggle="modal" style="margin-top: -615px;"
    data-toggle="modal" data-target="#chatmodel" [style.background-color]="style1 ? 'red' : (style2 ? 'blue' : null)"
           class="btn btn-blue btn-icon float-right"> <i class="fas fa-comment"></i>
       </button> -->
    <!-- Voice Recognition -->
    <div *ngIf="!pocForm.get('is_epaper')?.value">
      <form [formGroup]="pocForm" (ngSubmit)="onSubmit($event)">
        <div class="row">
          <div class="col-xl-5 mb-2">
            <div class="card mt-1 shadow cardrounded h-100">
              <div class="card-header"><strong> Chief Complaints / History of Present Illness </strong></div>
              <div class="card-body pt-2">
                <div class="mb-1">
                  <span class="button-checkbox mr-1" *ngIf="ccCgh">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onCCButtonSelect('Cough')">Cough</button>
                    <input type="checkbox" style="display: none;" />
                  </span>
                  <span class="button-checkbox mr-1" *ngIf="ccPrd">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onCCButtonSelect('Pain or Discomfort')">Pain or Discomfort</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox mr-1" *ngIf="ccRef">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onCCButtonSelect('Recurrent fever')">Recurrent Fever</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox" *ngIf="ccSwl">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onCCButtonSelect('Swelling')">Swelling</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>&nbsp;
                  <span class="button-checkbox" *ngIf="ccOther">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onCCButtonSelect('Other')">Other</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                </div>
                <div class="form-row small" formGroupName="cc_brief_history">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Chief Complaints <span class="text-danger">*</span>
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('CC')" *ngIf="moreCC"
                        class="ml-5"><b>{{txtMoreCC}}</b></a>&nbsp;&nbsp;
                        <!-- <div class="custom-control-inline custom-control custom-checkbox">
                        <input id="drgOther" class="custom-control-input" name="drgOther" type="checkbox" (change)="OthrDrg()">
                        <label class="custom-control-label" for="drgOther">Other</label>
                      </div> -->
                    </label>
                    <div tabindex="0" class="">
                      <!-- <select formControlName="chiefComplaints" id="chiefComplaints"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.chiefComplaints').errors }"
                        class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let chiefComplaint of chiefComplaintList" [value]="chiefComplaint.id">
                          {{chiefComplaint.chief_complaint}}</option>
                      </select> -->
                      <ng-multiselect-dropdown [settings]="ccdropdownSettings" [placeholder]="'Select'"
                        (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)" [(ngModel)]="selectedItemscc" 
                        [ngModelOptions]="{standalone: true}"
                        [data]="chiefComplaintList" [formControl]="pocForm.get('cc_brief_history.chiefComplaints')"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.chiefComplaints').errors }">
                      </ng-multiselect-dropdown>
                      <div *ngIf="submitted && pocForm.get('cc_brief_history.chiefComplaints').errors"
                        class="invalid-feedback">
                        <div *ngIf="pocForm.get('cc_brief_history.chiefComplaints').errors.required">
                          Chief Complaints is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-12" *ngIf="showTestField==1">
                    <label for="inputEmail4">Other (if any) </label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="othersifany" id="othersifany"
                        (keyup)="keyUp('othersifany')" maxlength="500"
                        class="form-control form-control-sm text-uppercase"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.othersifany').errors }">
                        <div *ngIf="submitted && pocForm.get('cc_brief_history.othersifany').errors"
                        class="invalid-feedback">
                        <div *ngIf="pocForm.get('cc_brief_history.othersifany').errors.required">
                          Other (if any) is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group col-md-12">
                    <label for="inputEmail4">Other Complaints </label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="otherComplaints" id="otherComplaints"
                        style="resize: none;" (keyup)="keyUp('otherComplaints')"
                        class="form-control form-control-sm text-uppercase"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.otherComplaints').errors }"></textarea>
                    </div>
                  </div> -->
                  <!-- <div class="form-group col-md-6">
                    <label for="inputEmail4">Sub Type</label>
                    <select class="form-control form-control-sm">
                      <option>Sub Type </option>
                      <option>Sub Type</option>
                      <option>Sub Type </option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Other SubType </label>
                    <select class="form-control form-control-sm">
                      <option>Other SubType </option>
                      <option>Other SubType </option>
                      <option>Other SubType </option>
                    </select>
                  </div> -->
                  <!-- <div class="form-group col-md-6">
                    <label for="inputEmail4">Doctor Comments</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="doctorComment" id="doctorComment"
                        (keyup)="keyUp('doctorComment')"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        maxlength="100"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.doctorComment').errors }"
                        class="form-control form-control-sm text-uppercase">
                    </div>
                  </div> -->
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">History of Present Illness</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="presentIllness" id="presentIllness"
                        (keyup)="keyUp('presentIllness')" maxlength="3500"
                        class="form-control form-control-sm text-uppercase"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.presentIllness').errors }">
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Family History</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="familyhistory" id="familyhistory"
                        (keyup)="keyUp('familyhistory')" maxlength="500"
                        class="form-control form-control-sm text-uppercase"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode == 44) ||(event.charCode == 46) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) || (event.charCode >= 48 && event.charCode <= 57)'
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('cc_brief_history.familyhistory').errors }">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 mb-2">
            <div class="card mt-1 shadow cardrounded h-100">
              <div class="card-header"><strong> Vitals </strong></div>
              <div class="card-body">
                <div class="form-row small" formGroupName="vital_history">
                  <div class="form-group col-md-6" *ngIf="vtlDt!=''">
                    <label for="inputEmail4"><b>Date: </b></label>{{vtlDt}}
                  </div>
                  <div class="form-group col-md-6" *ngIf="vtlTm!=''">
                    <label for="inputEmail4"><b>Time: </b></label>{{vtlTm}}
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Temperature</label>
                    <div class="input_wrapper">
                      <input type="text" formControlName="temperature" id="temperature"
                        (change)="onTempChng($event.target.value)" maxlength="5"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'
                        [ngClass]="{ 'is-invalid': (pocForm.get('vital_history.temperature').errors || tempErrMsg) }"
                        class="form-control form-control-sm text-uppercase" (keyup)="onTempChng($event.target.value)" />
                      <div class="unit">&deg; F</div>
                      <div *ngIf="pocForm.get('vital_history.temperature').errors" class="invalid-feedback">
                        <div>Accept value from 85 to 110</div>
                      </div>
                      <div *ngIf="tempErrMsg" class="invalid-feedback">
                        <!-- pocForm.get('vital_history.temperature').errors.pattern -->
                        <div> Enter Valid Decimal format. Eg.: 98.7 or 100.2 </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Sugar(mg/dl)</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="diabetic_value" id="diabetic_value"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.diabetic_value').errors }">
                      <div *ngIf="pocForm.get('vital_history.diabetic_value').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.diabetic_value').errors.min">Accept value from 50 to 800
                        </div>
                        <div *ngIf="pocForm.get('vital_history.diabetic_value').errors.max">Accept value from 50 to 800
                        </div>
                        <div *ngIf="pocForm.get('vital_history.diabetic_value').errors.required">Sugar is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Systolic</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="systolic" id="systolic"
                        (keyup)="keyUp('systolic')" (change)="onSysDia()"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.systolic').errors }"
                        class="form-control form-control-sm text-uppercase">
                      <div class="unit">mmHg</div>
                      <div *ngIf=" pocForm.get('vital_history.systolic').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.systolic').errors.min">Accept value from 50 to 250</div>
                        <div *ngIf="pocForm.get('vital_history.systolic').errors.max">Accept value from 50 to 250</div>
                        <div *ngIf="pocForm.get('vital_history.systolic').errors.sys">Enter Valid Value</div>
                        <div *ngIf="pocForm.get('vital_history.systolic').errors.required">Systolic is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Diastolic</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="diastolic" id="diastolic"
                        (keyup)="keyUp('diastolic')" (change)="onSysDia()"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.diastolic').errors }"
                        class="form-control form-control-sm text-uppercase">
                      <div class="unit">mmHg</div>
                      <div *ngIf=" pocForm.get('vital_history.diastolic').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.diastolic').errors.min"> Accept value from 40 to 160
                        </div>
                        <div *ngIf="pocForm.get('vital_history.diastolic').errors.max"> Accept value from 40 to 160
                        </div>
                        <div *ngIf="pocForm.get('vital_history.diastolic').errors.dia">Diastolic should be less than
                          Systolic</div>
                        <div *ngIf="pocForm.get('vital_history.diastolic').errors.required">Diastolic is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="!hidehmrbs">
                    <label for="inputEmail4">Hemoglobin</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="hemoglobin" id="hemoglobin" maxlength="4"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46'
                        class="form-control form-control-sm text-uppercase"
                        (change)="onHmglbnChng($event.target.value)">
                      <!-- (keyup)="onHmglbnChng($event.target.value)" [ngClass]="{ 'is-invalid': pocForm.get('vital_history.hemoglobin').errors }" -->
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="!hidehmrbs">
                    <label for="inputEmail4">RBS</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="rbsk" id="rbsk"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="30"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.rbsk').errors }"
                        class="form-control form-control-sm text-uppercase">
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Pulse</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="pulse" id="pulse" (keyup)="keyUp('pulse')"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57)' maxlength="3" max="200"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.pulse').errors }"
                        class="form-control form-control-sm text-uppercase">
                      <div class="unit">bpm</div>
                      <div *ngIf=" pocForm.get('vital_history.pulse').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.pulse').errors.min">Accept value from is 40 to 200</div>
                        <div *ngIf="pocForm.get('vital_history.pulse').errors.max">Accept value from is 40 to 200</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">SPO2%</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="oxigen_count" id="oxigen_count"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="3"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.oxigen_count').errors }">
                      <div *ngIf="pocForm.get('vital_history.oxigen_count').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.oxigen_count').errors.min">Accept value from 0 to 100
                        </div>
                        <div *ngIf="pocForm.get('vital_history.oxigen_count').errors.max">Accept value from 0 to 100
                        </div>
                        <div *ngIf="pocForm.get('vital_history.oxigen_count').errors.required">SPO2% is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Height(cm)</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="height" id="height"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="6"
                        (keyup)="onTempChng($event.target.value)" class="form-control form-control-sm text-uppercase"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.height').errors}">
                      <div class="unit">cm</div>
                      <div *ngIf="pocForm.get('vital_history.height').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.height').errors.min">Accept value from 30 to 240</div>
                        <div *ngIf="pocForm.get('vital_history.height').errors.max">Accept value from 30 to 240</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Weight</label>
                    <div class="input_wrapper">
                      <input type="text" autocomplete="off" formControlName="weight" id="weight"
                        onkeypress='return (event.charCode >= 48 && event.charCode <= 57) ' maxlength="6"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{ 'is-invalid': pocForm.get('vital_history.weight').errors }">
                      <div class="unit">kg</div>
                      <div *ngIf="pocForm.get('vital_history.weight').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('vital_history.weight').errors.min">Accept value from 1 to 250</div>
                        <div *ngIf="pocForm.get('vital_history.weight').errors.max">Accept value from 1 to 250</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <button class="badge badge-dark" type="button" (click)="openVitalFileModal()">
                      <i class="" aria-hidden="true"></i> <strong> View Vitals History</strong>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 mb-2">
            <div class="card mt-1 shadow cardrounded h-100">
              <div class="card-header"><strong> Past History </strong></div>
              <div class="card-body pt-2">
                <div class="mb-2">
                  <span class="button-checkbox mr-1">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onPHButtonSelect('Diabetes')">Diabetes</button>
                    <input type="checkbox" style="display: none;" />
                  </span>
                  <span class="button-checkbox mr-1">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onPHButtonSelect('Heart Disease')">Heart
                      Disease</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onPHButtonSelect('Hypertension')">Hypertension</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                </div>
                <div class="form-row small" formGroupName="other_history">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Past History</label>
                    <div>
                      <textarea type="text"  formControlName="history" id="history"
                        (keyup)="keyUp('history')"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('other_history.history').errors }"
                        class="form-control form-control-sm text-uppercase" style="resize: none;">
                        </textarea>
                    </div>
                  </div>
                </div>
                <div class="form-row small" formGroupName="allergy">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Allergies<span class="text-danger">*</span> : </label> &nbsp;&nbsp;&nbsp;
                    <span class="button-checkbox mr-1 mb-1">
                      <button type="button" class="btn btn-sm btn-teal"
                        (click)="onAllergyButtonSelect('None')">None</button>
                      <input type="checkbox" style="display: none;" />
                    </span>
                    <div>
                      <input type="text" autocomplete="off" formControlName="allergies" id="allergies"
                        (keyup)="keyUp('allergies')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                          (event.charCode == 32 || event.charCode == 46))' maxlength="50"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('allergy.allergies').errors }"
                        class="form-control form-control-sm text-uppercase">
                      <div *ngIf="submitted && pocForm.get('allergy.allergies').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('allergy.allergies').errors.required">
                          Allergies is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- new lines added for Findings #chandu 29-04-2022 -->
                <!-- <div class="form-row small" formGroupName="findings">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4"><strong>Findings :</strong></label>
                    <div>
                      <textarea type="text"  formControlName="findings" id="findings"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('findings.findings').errors }"
                        class="form-control form-control-sm text-uppercase" style="resize: none;">
                        </textarea>
                    </div>
                  </div>
                </div> -->
                <div class="form-row small">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Findings :</label>
                    <div>
                      <textarea type="text"  formControlName="findings" id="findings"   [(ngModel)]="findingsChar"  [maxlength]="maxChars"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('findings').errors }"
                        class="form-control form-control-sm" style="resize: none;">
                        </textarea>
                        <br/>
                        <br>
                        <label class="nopadding clrlbl"> Characters Remaining: {{findingsChar.length}}/{{maxChars}}</label>
                    </div>
                  </div>
                </div>
                <!-- Findings closed 29-04-2022 -->
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-4 mb-2">
            <div class="card mt-3 mb-1 shadow cardrounded h-100">
              <div class="card-header"><strong> Diagnosis </strong></div>
              <div class="card-body">
                <div class="mb-2">
                  <span class="button-checkbox mr-1 mb-1">
                    <button type="button" class="btn btn-sm btn-teal" (click)="onPDButtonSelect('Fever')">Fever</button>
                    <input type="checkbox" style="display: none;" />
                  </span>
                  <span class="button-checkbox mr-1 mb-1">
                    <button type="button" class="btn btn-sm btn-teal"
                      (click)="onPDButtonSelect('Diabetes')">Diabetes</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox mr-1 mb-1">
                    <button type="button" class="btn btn-sm btn-teal"
                      (click)="onPDButtonSelect('Hypertension')">Hypertension</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox mr-1 mb-1">
                    <button type="button" class="btn btn-sm btn-teal" (click)="onPDButtonSelect('Dengue')">Dengue</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox mr-1 mb-1">
                    <button type="button" class="btn btn-sm btn-teal mt-1"
                      (click)="onPDButtonSelect('Malaria')">Malaria</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                  <span class="button-checkbox mr-1 mb-1">
                    <button type="button" class="btn btn-sm btn-teal mt-1"
                      (click)="onPDButtonSelect('Typhoid')">Typhoid</button>
                    <input type="checkbox" style="display: none;" checked />
                  </span>
                </div>
                <div class="form-row small" formGroupName="diagnosis">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Provisional Diagnosis/ Diagnosis</label> -->
          <!-- <div>
                      <select formControlName="provisionalDiagnosis" id="provisionalDiagnosis"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('diagnosis.provisionalDiagnosis').errors }"
                        class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let diagnosisl of diagnosislList" [value]="diagnosisl.id">
                          {{diagnosisl.diagnosis_name}}</option>
                      </select>
                    </div> -->
          <!-- <div>
                      <input type="text" autocomplete="off" formControlName="provisionalDiagnosis"
                        id="provisionalDiagnosis" (keyup)="keyUp('provisionalDiagnosis')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)  ||
                        (event.charCode == 32 || event.charCode == 46 || event.charCode == 44))' maxlength="100"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('diagnosis.provisionalDiagnosis').errors }"
                        class="form-control form-control-sm text-uppercase">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="col-xl-4 mb-2">
            <div class="mt-3 mb-1 shadow cardrounded h-100">
              <div class="card-header"><strong>Provisional Diagnosis </strong></div>
              <!-- <div class="card-body"> -->
                <div class="pt-2 ml-4">
                  <span class="button-checkbox mr-1" *ngIf="pdOther">
                    <button type="button" class="btn btn-sm btn-teal mb-1"
                      (click)="onPdButtonSelect('Other')">Other</button>
                    <input type="checkbox" style="display: none;" />
                  </span>
                  </div>
                  <!-- </div> -->
              <div class="card-body">
                <div class="form-row small" formGroupName="diagnosis">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Type Of Diagnosis
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('PD')" *ngIf="morePD"
                        class="ml-5"><b>{{txtMorePD}}</b></a>
                    </label>
                    <div>
                      <!--sushma 22-07-2022 type of diagnosis values based on search  -->
                      <input type="text" class="form-control form-control-sm mb-2" [(ngModel)]="typeOfdiagnosis" [ngModelOptions]="{standalone: true}"
                      (keyup)="typeDiagnosis()" id="txtdiagno" Placeholder="Please Enter Minimum 3 Characters">
                      <!-- <ng-multiselect-dropdown [settings]="diagnosysdropdownSettings" [placeholder]="'Select'"
                        (onSelect)="onSelectPD($event, 's')" (onDeSelect)="onSelectPD($event, 'd')"  [(ngModel)]="selectedItemstd"
                        [ngModelOptions]="{standalone: true}"
                        [data]="diagnosysgroupList" [formControl]="pocForm.get('diagnosis.provisionalDiagnosis')">
                      </ng-multiselect-dropdown> -->
                      <!--  -->
                      <div *ngIf="(typeOfdiagnosis?.length > 2) || checkedLst.length > 0">
                        <ng-multiselect-dropdown [settings]="diagnosysdropdownSettings" [placeholder]="'Select'" 
                      (onSelect)="onSelectPD($event, 's')" (onDeSelect)="onSelectPD($event, 'd')"   [(ngModel)]="selectedItemstd" 
                        [ngModelOptions]="{standalone: true}" 
                        [data]="typeofDiagnosisLst" [formControl]="pocForm.get('diagnosis.provisionalDiagnosis')" >
                      </ng-multiselect-dropdown>
                      </div>
                      <!-- <select formControlName="provisionalDiagnosis" id="provisionalDiagnosis" 
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('diagnosis.provisionalDiagnosis').errors }"
                        class="form-control form-control-sm">
                        <option value="">Select</option>                      
                        <option *ngFor="let diognotypes of diagnosysgroupList" [value]="diognotypes.id">
                          {{diognotypes.diagnosis_name}}</option>
                      </select> -->
                    </div>
                  </div>
                  <div class="form-group col-md-12" *ngIf="isShowPDOthr">
                    <label for="inputEmail4">Other (if any) </label>
                    <div>
                      <textarea style="resize: none; height: 100px;" autocomplete="off" formControlName="othersifany"
                        maxlength="500" class="form-control form-control-sm" id="pdOthers"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 mb-2">
            <div class="mt-3 shadow cardrounded h-100">
              <div class="card-header"><strong> Investigations </strong></div>
              <div class="card-body">
                <div class="form-row small" formGroupName="investigation">
                  <div class="form-group col-md-12">
                    <label for="inputEmail4">Laboratory Investigations
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('IN')" *ngIf="moreIN"
                        class="ml-5"><b>{{txtMoreIN}}</b></a>
                    </label>
                    <div tabindex="0" class="">
                      <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Select'" [(ngModel)]="selectedItemsinvestgations"
                      [ngModelOptions]="{standalone: true}"
                        [data]="investigationsList" [formControl]="pocForm.get('investigation.master')">
                      </ng-multiselect-dropdown>
                      <!-- <select formControlName="master" id="master"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('investigation.master').errors }"
                        class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let item of investigationsList" [value]="item.id">
                          {{item.investigation}}</option>
                      </select> -->
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <label for="inputPassword4">Other Investigations</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="otherInvestigation" id="otherInvestigation"
                        (keyup)="keyUp('otherInvestigation')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)  ||
                        (event.charCode == 32 || event.charCode == 46))' maxlength="100"
                        class="form-control form-control-sm text-uppercase"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('investigation.otherInvestigation').errors }">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 mb-2">
            <div class="card mt-3 shadow cardrounded h-100">
              <div class="card-header"><strong> Advice </strong> </div>
              <div class="card-body">
                <div class="form-row small" formGroupName="advice">
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Rest/Exercise</label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="restExercise" id="restExercise"
                        (keyup)="keyUp('restExercise')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))' maxlength="100" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.restExercise').errors }"
                        class="form-control form-control-sm text-uppercase"></textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputPassword4">Diet</label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="diet" id="diet" (keyup)="keyUp('diet')"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))' maxlength="100" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.diet').errors }"
                        class="form-control form-control-sm text-uppercase"></textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Follow Advice</label>
                    <div>
                      <textarea type="text" autocomplete="off" formControlName="followAdvice" id="followAdvice"
                        (keyup)="keyUp('followAdvice')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))' maxlength="100" style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followAdvice').errors }"
                        class="form-control form-control-sm text-uppercase"></textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Doctor Comments</label>
                    <div>
                      <!-- <input type="text" autocomplete="off" formControlName="doctorComment" id="doctorComment"
                        (keyup)="keyUp('doctorComment')" maxlength="100" (focus)="dp.hide()"
                        onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                          (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) ||
                          (event.charCode >= 48 && event.charCode <= 57)'
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.doctorComment').errors }"
                        class="form-control form-control-sm text-uppercase"> -->
                      <textarea type="text" autocomplete="off" formControlName="doctorComment" id="doctorComment"
                        (keyup)="keyUp('doctorComment')" maxlength="100" (focus)="dp.hide()" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                            (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32)) ||
                            (event.charCode >= 48 && event.charCode <= 57)' style="resize: none;"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.doctorComment').errors }"
                        class="form-control form-control-sm text-uppercase"></textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Follow up Date</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="followupDate" id="followupDate"
                        placeholder="Follow up Date" bsDatepicker [minDate]="minDate" #dp="bsDatepicker"
                        (focus)="dp.show()"
                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,adaptivePosition: true,isAnimated: true }"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.followupDate').errors }"
                        class="form-control form-control-sm">
                    </div>
                  </div>
                  <!-- <div class="form-group col-md-6" *ngIf="!hospitalId">
                    <label for="inputPassword4">Referral</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="referral" id="referral" (focus)="dp.hide()"
                        (keyup)="keyUp('referral')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))' maxlength="100"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.referral').errors }"
                        class="form-control form-control-sm text-uppercase">
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="hospitalId">
                    <label class="control-label">Qualification </label>
                    <div>
                      <select formControlName="qualification_id" id="qualification_id"
                        (change)="QualificationChanged($event.target.value)" (focus)="dp.hide()"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.qualification_id').errors }"
                        #QualificationId class="form-control form-control-sm">
                        <option value=null>Select</option>
                        <option *ngFor="let qualification of qualificationsList" [value]="qualification.id">
                          {{qualification.qualification}}</option>
                      </select>
                      <div *ngIf="submitted && pocForm.get('advice.qualification_id').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('advice.qualification_id').errors">Qualification is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6"
                    *ngIf="+pocForm.get('advice.qualification_id').value != 1 && hospitalId">
                    <label class="control-label"> Specialization <span class="text-danger">*</span>
                    </label>
                    <div>
                      <select formControlName="specialization_id" id="specialization_id" (change)="getDoctors()"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.specialization_id').errors }"
                        class="form-control form-control-sm">
                        <option value=null>Select</option>
                        <option *ngFor="let specialization of specializationList" [value]="specialization.id">
                          {{specialization.specialization}}</option>
                      </select>
                      <div *ngIf="submitted && pocForm.get('advice.specialization_id').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('advice.specialization_id').errors.required">Specialization is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6"
                    *ngIf="+pocForm.get('advice.qualification_id').value != 1 && hospitalId">
                    <label class="control-label"> Super Speciality Degree</label>
                    <div>
                      <select formControlName="super_qualification_id" id="super_qualification_id"
                        (change)="superSecialityDegree($event.target.value)" class="form-control form-control-sm">
                        <option value=null>Select</option>
                        <option *ngFor="let superSpecialityDegree of superSpecialityDegreeList"
                          [value]="superSpecialityDegree.id">{{superSpecialityDegree.qualification}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6"
                    *ngIf="+pocForm.get('advice.qualification_id').value != 1 && hospitalId">
                    <label class="control-label">Super Specialisation</label>
                    <div>
                      <select formControlName="super_specialization_id" id="super_specialization_id"
                        class="form-control form-control-sm" (change)="getDoctors()">
                        <option value=null>Select</option>
                        <option *ngFor="let super of super_SpecialisationList" [value]="super.id">
                          {{super.specialization}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="hospitalId">
                    <label class="control-label">Referral</label>
                    <div>
                      <select formControlName="referral_id" id="referral_id" class="form-control form-control-sm"
                        (change)="doctorChange($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let item of doctorList" [value]="item.id">
                          {{item.doctor_name?.toUpperCase() }}
                        </option>
                      </select>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- //referral -->
          <div class="col-xl-4 mb-2" style="display: none;">
            <div class="card mt-3 shadow cardrounded h-100">
              <div class="card-header"><strong> Referral </strong> </div>
              <div class="card-body">
                <div class="form-row small" formGroupName="advice">
                  <div class="form-group col-md-12" *ngIf="!hospitalId">
                    <label for="inputPassword4">Referral</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="referral" id="referral" (focus)="dp.hide()"
                        (keyup)="keyUp('referral')" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))' maxlength="100"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.referral').errors }"
                        class="form-control form-control-sm text-uppercase">
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="hospitalId">
                    <label class="control-label">Qualification </label>
                    <div>
                      <select formControlName="qualification_id" id="qualification_id"
                        (change)="QualificationChanged($event.target.value)" (focus)="dp.hide()"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.qualification_id').errors }"
                        #QualificationId class="form-control form-control-sm">
                        <option value=null>Select</option>
                        <option *ngFor="let qualification of qualificationsList" [value]="qualification.id">
                          {{qualification.qualification}}</option>
                      </select>
                      <div *ngIf="submitted && pocForm.get('advice.qualification_id').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('advice.qualification_id').errors">Qualification is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6"
                    *ngIf="+pocForm.get('advice.qualification_id').value != 1 && hospitalId">
                    <label class="control-label"> Specialization
                    </label>
                    <div>
                      <select formControlName="specialization_id" id="specialization_id" (change)="getDoctors()"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('advice.specialization_id').errors }"
                        class="form-control form-control-sm">
                        <option value=null>Select</option>
                        <option *ngFor="let specialization of specializationList" [value]="specialization.id">
                          {{specialization.specialization}}</option>
                      </select>
                      <!-- <div *ngIf="submitted && pocForm.get('advice.specialization_id').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('advice.specialization_id').errors.required">Specialization is required
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="form-group col-md-6"
                    *ngIf="+pocForm.get('advice.qualification_id').value != 1 && hospitalId">
                    <label class="control-label"> Super Speciality Degree</label>
                    <div>
                      <select formControlName="super_qualification_id" id="super_qualification_id"
                        (change)="superSecialityDegree($event.target.value)" class="form-control form-control-sm">
                        <option value=null>Select</option>
                        <option *ngFor="let superSpecialityDegree of superSpecialityDegreeList"
                          [value]="superSpecialityDegree.id">{{superSpecialityDegree.qualification}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6"
                    *ngIf="+pocForm.get('advice.qualification_id').value != 1 && hospitalId">
                    <label class="control-label">Super Specialisation</label>
                    <div>
                      <select formControlName="super_specialization_id" id="super_specialization_id"
                        class="form-control form-control-sm" (change)="getDoctors()">
                        <option value=null>Select</option>
                        <option *ngFor="let super of super_SpecialisationList" [value]="super.id">
                          {{super.specialization}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="hospitalId">
                    <label class="control-label">Referral</label>
                    <div>
                      <select formControlName="referral_id" id="referral_id" class="form-control form-control-sm"
                        (change)="doctorChange($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let item of doctorList" [value]="item.id">
                          {{item.doctor_name?.toUpperCase() }}
                          <!-- {{item.first_name + ' ' + item.last_name }} -->
                        </option>
                      </select>
                    </div>
                  </div>
                  <!--       <div class="form-group col-md-6" *ngIf="hospitalId">
                    <label class="control-label">Referral</label>
                    <div>
                      <select formControlName="referral_id" id="referral_id" class="form-control form-control-sm"
                        (change)="doctorChange($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let item of doctorList" [value]="item.id">
                          {{item.doctor_name?.toUpperCase() }}
                        </option>
                      </select>
                    </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="offset-xl-2 col-xl-8 mb-2" >
            <div class="card mt-3 shadow cardrounded h-100">
              <div class="card-header"><strong> Lab & Pharmacy </strong> </div>
              <div class="card-body">
                <div class="form-row small" *ngIf="appSrce==dipl">
                  <div class="form-group col-md-4">
                    <label for="inputPassword4">State</label>
                    <div>
                      <select class="form-control form-control-sm" id="labStateId" 
                        (change)="LoadRegionsbyStateId($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let st of lstStates" [value]="st.id">{{st.state_name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputPassword4">Region</label>
                    <div>
                      <select class="form-control form-control-sm" id="labRegnId"
                        (change)="LoadDistbyRegion($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let rgn of lstRegns" [value]="rgn.id">{{rgn.region_name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputPassword4">District</label>
                    <div>
                      <select class="form-control form-control-sm" id="labDistId"
                        (change)="LoadLabPharmabyDist($event.target.value)">
                        <option value="">Select</option>
                        <option *ngFor="let lstDis of lstDist" [value]="lstDis.id">{{lstDis.district_name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-row small" *ngIf="appSrce==dipl">
                  <div class="form-group col-md-4">
                    <label for="inputPassword4">Lab Preferred</label>
                    <div>
                      <select class="form-control form-control-sm" id="labLabs" formControlName="lab_id"
                        (change)="onLabsChng($event.target.value)">
                        <!-- [ngClass]="{ 'is-invalid': submitted && pocForm.get('lab_id').errors }" -->
                        <option value="">Select</option>
                        <option *ngFor="let lab of lstTelgLab" [value]="lab.id">{{lab.lab_name}}</option>
                      </select>
                      <!-- <div *ngIf="submitted && pocForm.get('lab_id').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('lab_id').errors.required">Lab Preferred is required</div>
                      </div> -->
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="inputPassword4"></label>
                    <div class="mt-2">
                      <input type="text" autocomplete="off" class="form-control form-control-sm text-uppercase"
                        id="labsPerc" readonly>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputPassword4">Pharmacy Preferred</label>
                    <div>
                      <select class="form-control form-control-sm" id="labPhrm" formControlName="pharmacy_id"
                        (change)="onPhrmcChng($event.target.value)">
                        <!-- [ngClass]="{ 'is-invalid': submitted && pocForm.get('pharmacy_id').errors }" -->
                        <option value="">Select</option>
                        <option *ngFor="let phrm of lstTelgPhrm" [value]="phrm.id">{{phrm.pharmacy_name}}</option>
                      </select>
                      <!-- <div *ngIf="submitted && pocForm.get('pharmacy_id').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('pharmacy_id').errors.required">Pharmacy Preferred is required</div>
                      </div> -->
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="inputPassword4"></label>
                    <div class="mt-2">
                      <input type="text" autocomplete="off" class="form-control form-control-sm text-uppercase"
                        id="labPhrmPerc" readonly>
                    </div>
                  </div>
                </div>
                <div class="form-row small" *ngIf="appSrce!=dipl">
                  <div class="form-group col-md-6">
                    <label for="inputPassword4">Lab Preferred</label>
                    <div>
                      <select formControlName="lab_id" id="lab" class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let lab of lstLabs" [value]="lab.id">{{lab.lab_name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputPassword4">Pharmacy Preferred</label>
                    <div>
                      <select formControlName="pharmacy_id" id="phrmcy" class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let phrm of lstPhmcy" [value]="phrm.id">{{phrm.pharmacy_name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-4 mb-2">
            <div class="card mt-3 shadow cardrounded h-100">
              <div class="card-header"><strong> Lab Preferred </strong> </div>
              <div class="card-body">
                <div class="form-row small">
                  <div class="form-group col-md-12">
                    <label for="inputPassword4">Lab</label>
                    <div>
                      <select formControlName="lab_id" id="lab" class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let lab of lstLabs" [value]="lab.id">{{lab.lab_name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 mb-2">
            <div class="card mt-3 shadow cardrounded h-100">
              <div class="card-header"><strong>Pharmacy Preferred </strong> </div>
              <div class="card-body">
                <div class="form-row small">
                  <div class="form-group col-md-12">
                    <label for="inputPassword4">Pharmacy</label>
                    <div>
                      <select formControlName="pharmacy_id" id="phrmcy" class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let phrm of lstPhmcy" [value]="phrm.id">{{phrm.pharmacy_name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-xl-12">
            <div class="mt-3 shadow cardrounded">
              <div class="card-header"><strong> Drugs </strong></div>
              <div class="card-body">
                <div class="form-row small" formGroupName="drugs">
                  <div class="form-group col-md-4">
                    <label for="inputEmail4">Drug Type
                      <a role="button" style="cursor: pointer;" (click)="LoadMO('DN')" *ngIf="moreDN"
                        class="ml-5"><b>{{txtMoreDN}}</b></a>
                    </label>
                    <div>
                      <!-- <select formControlName="drugType" id="drugType" (change)="getDrugsByType($event.target.value)"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugType').errors }"
                        class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let drugtypes of drugtypesList" [value]="drugtypes.id">
                          {{drugtypes.drug_type}}</option> 
                      </select> -->
                      <ng-multiselect-dropdown [settings]="drugSettings" id="drugType" [placeholder]="'Select'"
                      formControlName="dT" (onSelect)="onDrgSlct($event, 'dt')" (onDeSelect)="onDrgDeSlct('dt')"
                        [data]="drugtypesList" [(ngModel)]="dT" [ngModelOptions]="{standalone: true}">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputPassword4">Drug Name</label>
                    <!-- <span class="text-danger">*</span> -->
                    <div>
                      <!-- <select formControlName="drugName" id="drugName"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugName').errors }"
                        class="form-control form-control-sm">
                        <option value="">Select</option>
                        <option *ngFor="let item of drugnamesList" [value]="item.drug_id.id">
                          {{item.drug_id.drug_name}}</option>
                      </select> -->
                      <ng-multiselect-dropdown [settings]="drugNameSettings" [placeholder]="'Select'"
                      formControlName="dN" (onSelect)="onDrgSlct($event, 'dn')" [data]="drug_list"
                        (onDeSelect)="onDrgDeSlct('dn')" [(ngModel)]="dN" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.drugName').errors }">
                      </ng-multiselect-dropdown>
                      <div *ngIf="submitted && pocForm.get('drugs.drugName').errors" class="invalid-feedback">
                        <div *ngIf="pocForm.get('drugs.drugName').errors.required">Drug Name is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-3" *ngIf="!hideOtherDrugLabel">
                    <label for="inputPassword4">Other Drug Name</label>
                    <div>
                      <input type="text" autocomplete="off" formControlName="otherDrug" id="otherDrug"
                        (keyup)="keyUp('otherDrug')" maxlength="100"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.otherDrug').errors }"
                        class="form-control form-control-sm text-uppercase">
                    </div>
                  </div>
                  <div class="form-group col-md-1" style="padding-top:2%">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addRow()">Add</button>
                  </div>
                </div>
                <div class="card " style="border-radius: 1rem;" *ngIf="getRowFormControls.controls.length > 0">
                  <div class="card-body pt-1 bg_color pt-3">
                    <div class="d-none d-sm-none d-md-none d-lg-block">
                      <div class="row">
                        <div class="col-xl-2 col-md-4 col-4">
                          <h6>Medicines</h6>
                        </div>
                        <div class="col-xl-2 col-md-4 col-4">
                          <h6>Duration</h6>
                        </div>
                        <div class="col-xl-1 col-md-4 col-2">
                          <h6>Dosage</h6>
                        </div>
                        <div class="col-xl-2 col-md-4 col-2 text-center">
                          <h6>Relation with food</h6>
                        </div>
                        <!-- <div class="col-xl-3 col-lg-3 col-12 d-none d-md-none d-lg-none d-xl-block">
                          <h6 class="ml-xl-5">Relation with food</h6>
                        </div> -->
                        <div class="col-xl-2  col-md-2 col-2">
                          <h6>Period</h6>
                        </div>
                        <!-- <div class="col-xl-1 col-1">
                          <h6>Months</h6>
                        </div> -->
                        <div class="col-xl-1 col-1"></div>
                        <!-- <div class="col-xl-1 col-1"></div> -->
                        <!-- <div class="col-xl-1 col-1"></div> -->
                        <div class="col-xl-2 col-md-4 col-1">
                          <h6>Remarks</h6>
                        </div>
                      </div>
                    </div>
                    <div formArrayName="prescribed_medications"
                      *ngFor="let group of getRowFormControls.controls ; let i=index">
                      <div class="row" [formGroupName]="i">
                        <div class="col-xl-2  col-md-4 col-sm-12 col-12">
                          <h6 class="d-block d-sm-block d-md-block d-lg-none">Duration</h6>
                          <p class="mb-0"> <span class="text-danger" *ngIf="group.get('agentStock').value==''">*</span> {{group.get('name').value}} - {{group.get('agentStock').value==""?'0':group.get('agentStock').value}}</p>
                          <!-- <p class="mb-0">{{group.get('name').value}}</p> -->
                        </div>
                        <div class="col-xl-2 col-md-4 col-sm-12 col-12">
                          <h6 class="d-block d-sm-block d-md-block d-lg-none">Medicines</h6>
                          <div>
                            <div class="custom-control-inline custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" [id]="'mcheckbox'+(i+1)"
                                formControlName="mrng" (change)="onCheckbox(i)"
                                [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                              <label class="custom-control-label" [for]="'mcheckbox'+(i+1)">M</label>
                            </div>
                            <div class="custom-control-inline custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" [id]="'acheckbox'+(i+1)"
                                formControlName="aftr" (change)="onCheckbox(i)"
                                [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                              <label class="custom-control-label" [for]="'acheckbox'+(i+1)">A</label>
                            </div>
                          </div>
                          <div>
                            <div class="custom-control-inline custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" [id]="'echeckbox'+(i+1)"
                                formControlName="evng" (change)="onCheckbox(i)"
                                [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                              <label class="custom-control-label" [for]="'echeckbox'+(i+1)">E</label>
                            </div>
                            <div class="custom-control-inline custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" [id]="'ncheckbox'+(i+1)"
                                formControlName="night" (change)="onCheckbox(i)"
                                [ngClass]="{ 'is-invalid': submitted && group.get('mrng').errors }">
                              <label class="custom-control-label" [for]="'ncheckbox'+(i+1)">N</label>
                            </div>
                          </div>
                          <!-- <div *ngIf="submitted && group.get('mrng').errors"
                      class="invalid-feedback">
                      <div *ngIf="group.get('mrng').errors.invalid">
                        Duration is required
                      </div>
                    </div> -->
                        </div>
                        <div class="col-xl-1 col-md-4 col-sm-12 col-12">
                          <h6 class="d-block d-sm-block d-md-block d-lg-none">Dosage</h6>
                          <div class="form-inline">
                            <div class="form-group">
                              <input type="text" class="form-control form-control-sm" style="width: 50%" maxlength="20"
                                formControlName="dosage" placeholder=""
                                (change)="onValChng(i, $event.target.value, 'dosage')"
                                [ngClass]="{ 'is-invalid': submitted && group.get('dosage').errors }">&nbsp;
                              <!-- onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                                  (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57)||
                                  (event.charCode == 32  || (event.charCode == 44)))' -->
                              <!-- Ml -->
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-2 col-lg-1 col-md-4 col-sm-12 col-12">
                          <h6 class="d-block d-sm-block d-md-block d-lg-none">Relation with food</h6>
                          <!-- <div class="col-12 d-block d-md-block d-lg-block d-xl-none pl-5">
                            <h6 class="m-xl-5 m-0">Relation with food</h6>
                          </div> -->
                          <div class="ml-5">
                            <div class=" custom-control custom-radio eRdoBtn">
                              <input class="custom-control-input" type="radio" [id]="'bradio'+(i+1)"
                                formControlName="relfood" value="Before"
                                [ngClass]="{ 'is-invalid': submitted && group.get('relfood').errors }">
                              <label class="custom-control-label" [for]="'bradio'+(i+1)">Before</label>
                            </div>
                            <div class=" custom-control custom-radio eRdoBtn">
                              <input class="custom-control-input " type="radio" [id]="'aradio'+(i+1)"
                                formControlName="relfood" value="After"
                                [ngClass]="{ 'is-invalid': submitted && group.get('relfood').errors }">
                              <label class="custom-control-label" [for]="'aradio'+(i+1)">After</label>
                            </div>
                            <div class="custom-control custom-radio eRdoBtn">
                              <input class="custom-control-input" type="radio" [id]="'anyradio'+(i+1)"
                                formControlName="relfood" value="Anytime"
                                [ngClass]="{ 'is-invalid': submitted && group.get('relfood').errors }">
                              <label class="custom-control-label" [for]="'anyradio'+(i+1)">Anytime</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-2 col-md-2 col-sm-12  col-12">
                          <h6 class="d-block d-md-block d-lg-none">Period</h6>
                          <div class="form-group">
                            <select formControlName="period" id="period" (change)="onRowDDChange(i,$event.target.value)"
                              [ngClass]="{ 'is-invalid': submitted && group.get('period').errors }"
                              class="form-control form-control-sm" #Periodvalue>
                              <option value="">Select</option>
                              <option value="Days">Days</option>
                              <option value="Weeks">Weeks</option>
                              <option value="Months">Months</option>
                              <option value="Years">Years</option>
                            </select>
                            <div *ngIf="submitted && group.get('period').errors" class="invalid-feedback">
                              <div *ngIf="group.get('period').errors.required">
                                <!-- Period is required -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xl-1 col-md-2 col-sm-12 col-12">
                          <div class="form-group">
                            <input type="text" style="width: 6rem;" placeholder={{placeHolders[i]}} class="form-control form-control-sm" formControlName="count"
                              [ngClass]="{ 'is-invalid': submitted && group.get('count').errors }"
                              (change)="onValChng(i, $event.target.value, 'count')"
                              onkeypress='return (event.charCode >= 48 && event.charCode <= 57) '>
                          </div>
                        </div>
                        <!-- <div class="col-xl-2 col-md-2 col-sm-12  col-12"></div> -->
                        <div class="col-xl-2 col-lg-2 col-md-6 mb-1">
                          <table>
                              <tr>
                                  <td style="width: 100%;">
                                    <textarea formControlName="remarks" id="remarks" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                                      (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                                      (event.charCode == 32 || event.charCode == 46))' (keyup)="keyUp('remarks')"
                                      class="form-control form-control-sm"
                                      style="resize: none; height: 80px;">
                                    </textarea>
                                  </td>
                                  <td style="width: 10%;">
                                      <button (click)="deleteRow(i)" title="Delete"
                                          class="btn btn-sm btn-block btn-teal"
                                          style="background: #defbfa; border-color: #defbfa;">
                                          <i class="fa fa-trash text-danger"></i></button>
                                  </td>
                              </tr>
                          </table>
                      </div>
                      </div>
                    </div>
                    <div class="form-row" style="margin-bottom: -50px">
                      <div class="form-group col-md-12 text-center font-weight-bold">
                        <p>(Note: All Fields are Mandatory)</p>
                        <p>(<span class="text-danger">* </span>Mark Represents the Drugs Which have to be Brought from outside)</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row small">
                  <div class="form-group col-md-4 col-sm-12 col-12" >
                    <label for="">Type Of Consultation</label>
                    <select formControlName="type_of_consultation"  class="form-control form-control-sm">
                      <option *ngFor = "let item of ConsultationList"  [value] ="item.consultationType" >{{item.consultationType}}</option>
                      
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-sm-12 col-12"></div>
                  <div #myDiv class="form-group col-md-4 col-sm-12 col-12" style="margin-top: 30px;">
                    Require Physical consultation <input type="checkbox" name="checkbox" [(ngModel)]="isPcChecked" [ngModelOptions]="{standalone: true}" (click)="onPhysicalConsultation($event)">
                  </div>
                </div>
                <div *ngIf="HimsReferral" class="p-2">

                  <div class="form-group">
                    <label for="">HIMS Referral Hospital</label>
                    <select class="form-control form-control-sm"  formControlName="referral_center_id" (change)="onReferral($event.target.value)"
                      class="form-control form-control-sm ">
                      <option value="">Select</option>
                      <option *ngFor="let item of referralHospTypeList" [value]="item.id">{{item.centerName}}
                      </option>
    
                    </select>
                  </div>
                  <!-- <div class="form-group">
                    <label for="">Referral Hospital</label>
                    <ng-multiselect-dropdown [settings]="dropdownSettings_referral" [placeholder]="'Select'"
                      (onDeSelect)="onHospDeSelect($event)" (onSelect)="onHospChange($event)"
                      [(ngModel)]="selectedRefHp" [data]="refHospListNew" formControlName="referral_hospital">
                    </ng-multiselect-dropdown> -->
                    <!-- -->
    
                  <!-- </div> -->
    
                </div>
                <div class="form-row small" *ngIf="isukt">
                  <!-- code commented here 06-04-2022 -->
                  <!-- <div class="form-group col-md-4 col-sm-12 col-12" *ngIf="!refdivshow">
                    <label for="">Type Of Referral Hospital</label>
                    <select formControlName="referral_type" (change)="onHospTypeChange($event.target.value)"  [(ngModel)]="Toh" class="form-control form-control-sm">
                      <option value = null >Select</option>
                      <option *ngFor = "let item of HospTypeList"  [value] ="item.id" >{{item.hospital_type}}</option>
                      
                    </select>
                  </div> -->
                  <!-- <div class="form-group col-md-4 col-sm-12 col-12"></div>
                  <div class="form-group col-md-4 col-sm-12 col-12" *ngIf="!refdivshow">
                    <label for="">Referral Hospital</label>
                    <select formControlName="referral_hospital" (change)="onHospChange($event.target.value)" [(ngModel)]="Rh" class="form-control form-control-sm">
                      <option value="">Select</option>
                      <option *ngFor = "let item of refHospList"  [value] ="item.id" >{{item.hospital_name}}</option>
                      
                    </select>
                  </div>
                </div> -->
                 <!-- code commented close here 06-04-2022 chandu-->
                 <div class="form-group col-md-4 col-sm-12 col-12" *ngIf="!refdivshow">
                  <label for="">Type Of Referral Hospital</label>
                  <select class="form-control form-control-sm" (change)="onHospTypeChange($event.target.value)"  class="form-control form-control-sm">
                    <option value="">Select</option>
                    <option *ngFor = "let item of HospTypeList"  [value] ="item.id" >{{item.hospital_type}}</option>
                    
                  </select>
                </div>
                  <div class="form-group col-md-4 col-sm-12 col-12"></div>
                  <div class="form-group col-md-4 col-sm-12 col-12" *ngIf="!refdivshow && refHospListNew">
                    <label for="">Referral Hospital</label>
                    <ng-multiselect-dropdown [settings]="dropdownSettings_referral" [placeholder]="'Select'"
                    (onDeSelect)="onHospDeSelect($event)"    (onSelect)="onHospChange($event)" [(ngModel)]="selectedRefHp"  
                      
                        [data]="refHospListNew"  formControlName="referral_hospital" >
                      </ng-multiselect-dropdown>
                      <!-- -->
                    <!-- <select formControlName="referral_hospital" (change)="onHospChange($event.target.value)" [(ngModel)]="Rh" class="form-control form-control-sm">
                    <option value="">Select</option>
                      <option *ngFor = "let item of refHospListNew"  [value] ="item.id" >{{item.hospital_name}}</option>
                      
                    </select> -->
                    <!-- <ng-select formControlName="referral_hospital"  [placeholder]="''" (change)="onHospChange($event.target.value)">
                      <ng-option *ngFor="let item of refHospListNew" [value]="item.id">{{item.hospital_name}}</ng-option>
                   </ng-select> -->
                  </div>
                </div>
                <div class="form-row small" formGroupName="drugs">
                  <div class="form-group col-md-4 col-sm-12 col-12">
                    <label for="inputPassword4">Instructions</label>
                    <div>
                      <textarea formControlName="instruction" id="instruction" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))' (keyup)="keyUp('instruction')"
                        class="form-control form-control-sm"
                        [ngClass]="{ 'is-invalid': submitted && pocForm.get('drugs.instruction').errors }"
                        style="resize: none; height: 100px;">
                      </textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-3 col-sm-12 col-12" *ngIf="refdivshow">
                    <label for="inputPassword4">Procedure</label>
                    <div>
                      <!-- <textarea id="procedurevalue" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))'
                        class="form-control form-control-sm"
                        style="resize: none; height: 100px;">
                      </textarea> -->
                      <textarea rows="5" cols="50" wrap="physical" class="form-control form-control-sm" style="height: 100px;" (blur)="onProcedure()" name="comments" id="procedurevalue" onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) ||
                        (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 48 && event.charCode <= 57) ||
                        (event.charCode == 32 || event.charCode == 46))'></textarea>
                    </div>
                  </div>
                  <div class="form-group col-md-2 col-sm-12 col-12" *ngIf="refdivshow" style="margin-top: 30px;">
                    <label for="inputPassword4">Doctor Name</label>
                    <div>
                    <input type="text" class="form-control"  id="refdoctorName" style="height: 33px">
                    </div>
                  </div>
                  <div class="form-group col-md-2 col-sm-12 col-12" *ngIf="refdivshow" style="margin-top: 30px;">
                    <label for="inputPassword4">Status</label>
                    <div>
                      <select  id="statusvalue" formControlName="refstatus" (change)="onRefStatusChange($event.target.value)"
                      class="form-control form-control-sm">
                     <option value="">Select</option>
                     <option *ngFor="let sts of statusget" [value]="sts.id">
                       {{sts.referral_type}}</option>
                   </select>
                    </div>
                    </div>
                  <div class="form-group col-md-4 col-sm-12 col-12"></div>
                  <div class="form-group col-md-3 mt-10 text-right">
                    <button type="button" class="btn btn-sm btn-dark" (click)="onPreview($event)"><i
                        class="fa fa-prescription"></i>&nbsp;Preview Prescription</button>&nbsp;
                  </div>
                </div>
                <div class="form-row  small" hidden>
                  <div class="form-group  col-md-12 text-right">
                    <!-- <button type="button" class="btn btn-sm btn-dark" (click)="onPreview($event)"><i
                      class="fa fa-prescription"></i>&nbsp;Preview Prescription</button>&nbsp; -->
                    <button type="button" id="btnPreviewModal" data-toggle="modal"
                      data-target="#exampleModal_1"></button>
                    <button type="button" id="btncontinueModal" data-toggle="modal" data-target="#continue"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="pocForm.get('is_epaper').value">
      <div class="row">
        <div class="col-xl-12">
          <div class="card mt-3 shadow cardrounded">
            <div class="card-header"><strong> Digital Prescription </strong></div>
            <div class="card-body">
              <div class="form-row small">
                <div class="form-group col-md-4">
                  <div class="custom-control-inline custom-control custom-radio eRdoBtn">
                    <input class="custom-control-input" type="radio" id="isUpld" value="Upload"
                      (change)="isDgtl='Upload';isPrvwHdn=true" [checked]="isDgtl=='Upload'">
                    <label class="custom-control-label" for="isUpld">File Upload</label>
                  </div>
                  <div class="custom-control-inline custom-control custom-radio eRdoBtn">
                    <input class="custom-control-input" type="radio" id="isCmra" value="Camera"
                      (change)="isDgtl='Camera';isPrvwHdn=true" [checked]="isDgtl=='Camera'">
                    <label class="custom-control-label" for="isCmra">Image Capture</label>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <div class="custom-file" *ngIf="isDgtl=='Upload'">
                    <!-- <div class="col-xl-11 col-1"> -->
                    <input type="file" class="custom-file-input" id="dgtlPres" (change)="onFile($event)"
                      accept="image/jpeg,image/jpg,image/png" #dgtlPres>
                    <label class="custom-file-label form-control-sm" for="dgtlPres">Digital Prescription</label>
                    <span class="text-primary" *ngIf="false">Dimensions should be 300(w) * 80(h)</span>&nbsp;
                    <!-- </div>
                        <div class="col-xl-1 col-1"> -->
                    File format should be jpg/jpeg/png&nbsp;&nbsp;&nbsp;<br />
                    <span *ngIf="dgtlFile">
                      <span *ngIf="upldFile!=''">
                        <a href="javascript:void(0)" class="fa fa-eye" title="View File" (click)="viewFile()"
                          *ngIf="upldFile!=''"><i class=""></i>&nbsp;{{upldFile}}</a>
                      </span>
                    </span>
                    <!-- </div> -->
                  </div>
                </div>
                <div class="form-group col-md-4" style="padding-top: 0.2%;" *ngIf="isDgtl=='Upload'">
                  <button type="button" class="btn btn-sm btn-primary" (click)="uploadImg()"
                    [disabled]="!(dgtlFile!=undefined && dgtlFile!=null && upldFile!='')">Upload &
                    Save</button>&nbsp;&nbsp;&nbsp;
                  <button class="btn btn-sm btn-danger" (click)="upldFile=''">Clear</button>
                </div>
              </div>
              <!-- <div class="form-row small" [hidden]="isDgtl!='Camera'">         
                <div class="form-group col-md-4" style="text-align: center;"><span></span></div>              
                <div class="form-group col-md-4" style="text-align: center; padding-left: 10%;" *ngIf="webcamImage">
                  <span><strong>Preview</strong></span>
                </div>              
              </div> -->
              <div class="row" [hidden]="isDgtl!='Camera'">
                <div class="col-xl-6 h-100">
                  <strong>Camera</strong>
                  <div class="img-fluid text1">
                    <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="isDgtl=='Camera'"
                      [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                      [videoOptions]="videoOptions" [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)"
                      (initError)="handleInitError($event)" style="max-width: 100%; height:auto"></webcam>
                  </div>
                  <div class="mt-1 text-center">
                    <button class="btn btn-sm btn-orange" (click)="triggerSnapshot();isPrvwHdn=false">Freeze</button>
                  </div>
                </div>
                <div class="col-xl-6 h-100" [hidden]="isPrvwHdn">
                  <strong>Preview</strong>
                  <div class="snapshot" *ngIf="webcamImage">
                    <img [src]="webcamImage.imageAsDataUrl" class="img-fluid" />
                    <div class="mt-1 text-center">
                      <button *ngIf="webcamImage" class="btn btn-sm btn-success" (click)="uploadImg()">Upload &
                        Save</button> &nbsp;
                      <button *ngIf="webcamImage" class="btn btn-sm btn-danger"
                        (click)="webcamImage=null">Clear</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="form-row small" [hidden]="isDgtl!='Camera'">             
                <div class="form-group col-md-4">                
                </div>     
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Prescription</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-sm small">
          <tr class="active bg-light">
            <td colspan="4">
              <h6>Patient Details</h6>
            </td>
          </tr>
          <tr>
            <td><strong>Name</strong> </td>
            <td>{{benData?.first_name + ' '+  benData?.middle_name + ' ' + benData.last_name}}</td>
            <td><strong>ID</strong></td>
            <td></td>
          </tr>
          <tr>
            <td><strong>Phone Number</strong></td>
            <td>{{benData?.mobile}}</td>
            <td><strong>Age</strong></td>
            <td>{{benData?.age}}</td>
          </tr>
          <tr>
            <td><strong>Gender</strong></td>
            <td>{{benData?.gender_id == 1 ? 'Male' : 'Female'}}</td>
            <td><strong>Address</strong></td>
            <td>{{benData?.address}}</td>
          </tr>
          <tr>
            <td colspan="4" class="bg-light">
              <h6>Doctor Details</h6>
            </td>
          </tr>
        </table>
        <table class="table table-bordered table-sm small">
          <tr class="bg-light">
            <td class="active text-center" colspan="6">
              <h6>Prescription</h6>
            </td>
          </tr>
          <tr>
            <td colspan="3"><strong>Chief Complaints/ History of Present Illness:</strong></td>
            <td colspan="3">{{pocCc }}</td>
          </tr>
          <!-- <tr>
              <td colspan="3"><strong>Medical History:</strong></td>
              <td colspan="3">{{pocForm.get('medical_history.pastIllness').value + ',' + pocForm.get('medical_history.surgicalHistory').value}}</td>
            </tr> -->
          <tr>
            <td colspan="3"><strong>Vitals</strong></td>
            <td colspan="3">{{pocVitals}}</td>
          </tr>
          <tr>
            <td colspan="3"><strong>Past History & Allergies</strong></td>
            <td colspan="3">{{pocHistory}} </td>
          </tr>
          <tr>
            <td colspan="3"><strong>Provisional Diagnosis</strong> </td>
            <td colspan="3">{{provDgns}}</td><!-- <td colspan="3">{{pocCc}}</td> -->
          </tr>
          <tr>
            <td colspan="3"><strong>Investigations</strong></td>
            <td colspan="3">{{pocIn}}</td>
          </tr>
          <tr>
            <!-- Doctor Note  -->
            <td colspan="3"><strong> Doctor Note</strong></td>
            <td colspan="3">{{pocForm.get('advice.doctorComment').value}}</td>
          </tr>
          <tr>
            <th><strong>Drug Type</strong></th>
            <th>Drug Name</th>
            <th>Dosage</th>
            <th>Direction</th>
            <th>Instruction</th>
            <th>No of Days</th>
          </tr>
          <tr>
            <td>{{pocDrug.drug_type}}</td>
            <td>{{pocDrug.drug_name}}</td>
            <td>{{pocDrug.dsg}}</td>
            <td>{{pocDrug.dir}}</td>
            <td>{{pocDrug.ins}}</td>
            <td>{{pocDrug.noofdays}}</td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn  btn-sm btn-primary" (click)="onSubmit($event)">Submit</button>
      </div>
    </div>
  </div>
</div>
<!-- New Modal -->
<div class="modal fade" id="exampleModal_1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Prescription</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <table border="0" style="background-color:#f8f6f6;width:100%;">
          <tr>
            <td style="padding: 20px;">
              <table class="" border="0" cellpadding="4" cellspacing="4"
                style="width: 100%; font-size:14px; background-color: #f8f6f6; padding: 4px;"
                [ngStyle]="{ 'background': 'url(' + bg + ')', 'background-repeat': 'no-repeat', 'background-position': 'center', 'background-attachment': 'cover' }">
                <tr style="background-color:#f2f2f2;">
                  <td colspan="6">
                    <table border="0" style="width:100%;">
                      <tr>
                        <td><img src="../../../assets/images/prescription.png"></td>
                        <td valign="middle">
                          <address style="margin-bottom: 0px !important;"><small>
                              <strong>{{doc.first_name+ '' + doc.last_name}}</strong>
                              {{doc.qualification + ((doc.superspecialiy != undefined) ? ', ' + doc.superspecialiy : ''
                              )}}<br />
                              <strong>MCI Number :</strong>{{doc.mci}}<br />
                              {{doc.address}}
                            </small>
                          </address>
                        </td>
                        <td align="right"><img [src]="presLogo"></td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr style="height:2px;">
                  <td colspan="6"></td>
                </tr>
                <tr>
                  <td><strong>Name</strong> </td>
                  <td>{{benData?.first_name + '' + benData?.last_name}}</td>
                  <td><strong>ID</strong> </td>
                  <td>9247248376</td>
                  <td><strong>Phone Number </strong></td>
                  <td>{{benData?.mobile}}</td>
                </tr>
                <tr>
                  <td><strong>Age</strong> </td>
                  <td>{{benData?.age}}</td>
                  <td><strong>Gender</strong> </td>
                  <td>{{benData?.gender_id == 1 ? 'Male' : 'Female'}}</td>
                  <td><strong>Address</strong> </td>
                  <td>{{benData?.address}}</td>
                </tr>
                <tr>
                  <td colspan="6">
                    <hr style="border:1px solid #17c5bb">
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table cellpadding="2">
                      <tbody>
                        <tr>
                          <td>
                            <h6 class="mb-0">Chief Complaints/ History of Present Illness: </h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocCc}} </td>
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <h6 class="mb-0">Vitals</h6>
                          </td>
                        </tr>
                        <tr>
                          <td> {{pocVitals}} </td>
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <h6 class="mb-0">Past History &amp; Allergies:</h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocHistory}} </td>
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <h6 class="mb-0">Provisional Diagnosis </h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{provDgns}}</td>
                          <!-- <td> {{pocForm.get('diagnosis.provisionalDiagnosis').value}} </td> -->
                        </tr>
                        <tr style="height: 5px;">
                          <td></td>
                        </tr>
                        <!-- <tr><td><h6 class="mb-0">Investigations </h6></td></tr>
                          <tr><td>  CBP, SMEAR FOR MP, WIDAL</td></tr>
                          <tr style="height: 5px;"><td></td></tr> -->
                        <tr>
                          <td>
                            <h6 class="mb-0">Advice </h6>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocAdvice}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table border="0" style="width:100%;" cellpadding="2">
                      <tbody>
                        <tr style="background-color: #17c5bb; color: #ffffff;">
                          <th>S.No</th>
                          <th>Drug Type</th>
                          <th>Drug Name</th>
                          <th>Dosage</th>
                          <th>Direction</th>
                          <th>Instructions</th>
                          <th>Period</th>
                        </tr>
                        <tr *ngFor="let item of getRowFormControls.value;let i=index;">
                          <td>{{(i+1)}}</td>
                          <td>{{item.type}}</td>
                          <td>{{item.name}}</td>
                          <td>{{item.dosage}}</td>
                          <td>{{(item.mrng==true?'X':'0')+' - '+(item.aftr==true?'X':'0')+' -
                            '+(item.evng==true?'X':'0')}}</td>
                          <td>{{item.relfood != 'Anytime' ? (item.relfood + ' Food') : item.relfood}}</td>
                          <td>{{item.count}}&nbsp;{{item.period}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <hr style="border:1px solid #17c5bb">
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table cellpadding="2">
                      <tbody>
                        <tr>
                          <td colspan="2">
                            <h5>Lab Test</h5>
                          </td>
                        </tr>
                        <tr *ngFor="let item of pocForm.get('investigation.master').value;let i = index">
                          <td>{{i+1}}</td>
                          <td>{{item.investigation}} </td>
                        </tr>
                        <tr>
                          <td>
                            {{pocForm.get('investigation.otherInvestigation').value != '' ?
                            ((pocForm.get('investigation.master').value) != '' ?
                            ((pocForm.get('investigation.master').value).length + 1) : '1') : ''}}
                          </td>
                          <td>{{pocForm.get('investigation.otherInvestigation').value}}</td>
                        </tr>
                        <!-- <tr><td>2</td><td> Liver Function Test  </td></tr>
                    <tr><td>3</td><td> CBP </td></tr>
                    <tr><td>4</td><td> Liver Function Test  </td></tr> -->
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table cellpadding="2">
                      <tbody>
                        <tr>
                          <td>
                            <h5>Follow Up</h5>
                          </td>
                        </tr>
                        <tr>
                          <td>{{pocForm.value.advice.followupDate | date :'dd-MM-yyyy HH:mm:ss'}} </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" align="center">
                    <hr style="border:1px solid #17c5bb; margin-bottom:0px;">
                    <small style="font-size: 10px; text-align: center;">Substitue medicine brand if above unavilble
                      unless Doctor Says not to</small>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <table border="0" style="width:100%; padding: 20px;">
                      <tr>
                        <td valign="middle" style="padding: 0px 20px;">

                          <img
                            src="data:image/png;base64,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"
                            width="100px">
                          <address><small>
                              <strong> Dr Sharanya Reddy</strong>
                            </small>
                          </address>
                        </td>
                        <td align="right" style="padding:0px 20px;"><img src="../../../assets/images/qrcode.png"
                            style="width:50px;"> <br />
                          For support please contact VIDMED:<br /> 040-66336663
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr style="background-color:#f2f2f2;">
            <td colspan="6" align="center">
              <hr style="border:1px solid #17c5bb; margin-bottom:0px;">
              <small style="font-size: 14px; text-align: center;">Vidmed Pharmacy Pharmacy, Ameerpet, Hyderabad,
                Telangana, Contact : 9849012835 </small>
            </td>
          </tr>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"
          id="prescriptionModalClose">Close</button>
        <button type="button" class="btn  btn-sm btn-primary" (click)="onSubmit($event)">Submit</button>
      </div>
    </div>
  </div>
</div>
<!-- Patient Modal -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" style="z-index: 99999 !important;"
  id="patientModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Patient History</h5>
        <button type="button" id="patientHistoryButton" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-sm">
          <!-- <tr class="bg-light">
            <th colspan="4">Medications</th>
          </tr> -->
          <tr>
            <th>Date</th>
            <!-- <th>Medications Given</th> -->
            <th>Doctor Name</th>
            <th>Follow Up</th>
            <th>View File</th>
          </tr>
          <tr *ngFor="let item of benHistory">
            <td>{{item.visit_date | date :'dd-MM-yyyy'}}</td>
            <td>
              {{item.doctor_id.first_name}} {{item.doctor_id.last_name}}
              <!-- <div *ngFor="let itm of item.prescribed_medications">
                {{itm.name}}
              </div> -->
            </td>
            <td>
              <div *ngIf="item.doctor_id?.first_name==docData?.first_name  || item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory!=true " class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
              <a (click)="followupclick(item)"> <i class="fa fa-edit text-white"></i></a> 
            </div>
            <div *ngIf="item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory==true" class="badge badge-pill" title="Prescription" style="background-color: #cfdcf1;">
              <a (click)="followupclick2()"> <i class="fa fa-edit text-white"></i></a> 
            </div>
          </td>
            <td>
              <div  *ngIf="item.doctor_id?.first_name==docData?.first_name  || item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory!=true " class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
                <a (click)="imgPath='';openpath(item)"> <i class="fa fa-eye text-white"></i></a> <!-- item -->
                <!-- openModal(item) -->
              </div>
              <div *ngIf="item.doctor_id?.first_name!=docData?.first_name && pocpatientHistory==true" class="badge badge-pill" title="Prescription" style="background-color: #cfdcf1;">
                <a (click)="imgPath='';followupclick2()"> <i class="fa fa-eye text-white"></i></a> 
              
              </div>
            </td>
        
          </tr>
        </table>
        <table class="table table-bordered table-sm" style="display: none;">
          <tr class="bg-light">
            <th colspan="4">Diagnosis History</th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Diagnosis</th>
            <th>Doctor Note</th>
            <th>View File</th>
          </tr>
          <tr>
          <tr *ngFor="let item of lstbenHstry">
            <!-- benHistory  -->
            <td>{{item.visit_date | date :'dd-MM-yyyy HH:mm:ss'}}</td>
            <td>{{item.dgns}}</td>
            <td>{{item.docCmnt}}</td>
            <td>
              <div class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
                <a (click)="imgPath='';onViewPresOld(item)"> <i class="fa fa-eye text-white"></i></a> <!-- item -->
                <!-- openModal(item) -->
              </div>
            </td>
            <!-- <td>{{item.visit_date | date :'dd-MM-yyyy'}}</td>
            <td>{{item.diagnosis.provisionalDiagnois}}</td>
            <td>{{item.advice.doctorComment}}</td> -->
          </tr>
        </table>
        <table class="table table-bordered table-sm" style="display: none;">
          <tr class="bg-light">
            <th colspan="2">Lab Investigations </th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Investigation</th>
            <!-- <th>View</th> -->

          </tr>
          <tr *ngFor="let item of benHistory">
            <td>{{item.visit_date | date :'dd-MM-yyyy '}}</td>
            <td>
              <div *ngFor="let itm of item.investigation.master">
                {{itm.investigation}}
              </div>
            </td>
            <!-- <td><div class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
              <a (click)="imgPath='';onViewPresOld(item.investigation.master)"> <i class="fa fa-eye text-white"></i></a> 
          
            </div></td> -->
          </tr>
        </table>
        <!-- <table class="table table-bordered table-sm">
          <tr class="bg-light">
            <th colspan="4">Medications</th>
          </tr>
          <tr>
            <th>Date</th>
            <th>Medications Given</th>
            <th *ngIf="isukt">Follow Up</th>
          </tr>
          <tr *ngFor="let item of benHistory">
            <td>{{item.visit_date | date :'dd-MM-yyyy'}}</td>
            <td>
              <div *ngFor="let itm of item.prescribed_medications">
                {{itm.name}}
              </div>
            </td>
            <td *ngIf="isukt"><div class="badge badge-primary badge-pill" title="Prescription" style="cursor: pointer;">
              <a (click)="followupclick(item)" data-dismiss="modal"> <i class="fa fa-edit text-white"></i></a> 
            </div></td>
            
        
          </tr>
        </table> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Alert -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
  id="continue" role="dialog" aria-labelledby="edit" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"> Medicines are not specified, Do you want to continue?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm  btn-primary" data-dismiss="modal"
          (click)="yesContinue = true; openPrescriptionModal()" data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<!-- Emergency -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
  id="emergencyModal" role="dialog" aria-labelledby="edit" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Do you want to Exit the Plan of Care ?</h5>
        <button type="button" id="buttonEmergency" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group ">
          <div class="col-md-12">
            <label>Comments</label>
            <textarea type="text" rows="5" class="form-control form-control-sm"
              [(ngModel)]="emergencyComment"> </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm  btn-primary" data-dismiss="modal" (click)="emergencyExit()"
          data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<!-- Confirm Message for doctor to close the video call -->
<button type="button" class="d-none" data-toggle="modal" data-target="#confirmMessage" id="btnConfirmMessage"></button>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="confirmMessage" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Confirmation Message</h5>
        <button type="button" id="btnConfirmMessageClose" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Patient/Agent has disconnected the video consultation,
        but still do you want to provide plan of care?
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-primary btn-sm" onclick="window.webComponent.style.display='none'" -->
        <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal">Yes</button>
        <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal"
          (click)="gotoConsultation()">No</button>
      </div>
    </div>
  </div>
</div>
<input type="button" (click)="chkTstrMsg()" id="eTest" hidden>
<input type="button" (click)="withOut_PrescriptionSumitted()" id="bntwithOut_Prescription" class="d-none">
<!-- <div class="modal fade" data-backdrop="static" data-keyboard="false" style="z-index: 99999 !important;"
  id="chatmodel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div style="margin-left: 340px;">
          <b>Chat</b>
        </div>
        
        <button type="button" id="closeid" class="close" data-dismiss="modal" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div id="chatalign" *ngFor="let item of chatArray;let ind=index;">
<span style="margin-left: 20px;font-size: medium;" >{{item.message}}</span>
      </div>
      <form >
        <div class="modal-footer">
          <div class='col-md-5'>
              <div class="form-group">
                <div class="input_wrapper2">
                  <input id="search_string" name="search_string" type="text" [(ngModel)]="messagechat" autocomplete="off"  
                      class="form-control" placeholder="Chat Here">
                      <div class="unit" *ngIf="messagechat !=''">
                        <button type="submit" class="btn btn-sm btn-primary">Send</button>
                      </div>
                    </div>
                     
              </div>
          </div>
        </div>
      </form>
     
    </div>
  </div>
</div> -->
<!-- <div class="modal fade t10" id="appModal" >
  <div class="modal-dialog">
    <div class="modal-content modalpopborder">  
      <div class="modal-header headerbg modalpopborderhead p-2">
        <h6 class="modal-title text-white">ID Proof</h6>
        <button type="button" id="closeid" class="close text-white" (click)="close()" >&times;</button>
      </div>  
      <div class="modal-body modalbodybg">
      <img src="https://vidmedplus.dhanushinfotech.com/vidmedfiles/BENEFICIARY/533/IdCard/533_1636463400304_4f0a9711-4f5b-4220-a0d7-3bfcae0e528d.jpg" alt="">
      </div>
    </div>
  </div>
  </div> -->


  <!-- Emergency -->
<div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" style="z-index: 99999 !important;"
id="audioConsent" role="dialog" aria-labelledby="edit" aria-hidden="true">
<div class="modal-dialog">
  <div class="modal-content" style="width:576px !important" >
    <div class="modal-header">
      <h5 class="modal-title">Audio Consent </h5>
      
      <button type="button" id="buttonEmergency" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
    
      <div class="player" style="width:100% !important; position: relative;" *ngIf="audioPath" > 
        <mat-advanced-audio-player [playlist]="playlist"[displayTitle]="false"
                      [displayPlaylist]="false">
        </mat-advanced-audio-player>
        
        
      </div>
      
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">Download</button>
      <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Close</button>
    </div>
  </div>
</div>
</div>